import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { tasksApi } from "@/lib/tasks";
import { TaskTypeBadge } from "@/components/tasks/TaskTypeBadge";
import { TaskStatusBadge } from "@/components/tasks/TaskStatusBadge";
import { formatDate } from "@/lib/format";

export function JobTasksList({ jobId }: { jobId: number }) {
  const jobTasksQuery = useQuery({
    queryKey: ["task-list", "job", jobId],
    queryFn: () => tasksApi.list({ jobId, scope: "all", pageSize: 50 }),
  });

  if (jobTasksQuery.isLoading) {
    return <p className="p-4 text-sm text-muted-foreground">Loading…</p>;
  }

  const items = jobTasksQuery.data?.items ?? [];
  if (items.length === 0) {
    return (
      <p className="p-4 text-sm text-muted-foreground">
        No tasks for this job yet.
      </p>
    );
  }

  return (
    <ul className="flex flex-col gap-1 mt-1">
      {items.map((t) => (
        <li key={t.id}>
          <Link
            to={`/tasks/${t.id}`}
            className="flex flex-wrap items-center gap-2 px-3 py-2 rounded-md hover:bg-slate-100 transition-colors"
          >
            <TaskTypeBadge taskType={t.taskType} />
            <span className="flex-1 truncate text-sm font-medium">{t.title}</span>
            {t.dueDateUtc && (
              <span className="text-xs text-muted-foreground">
                {formatDate(t.dueDateUtc)}
              </span>
            )}
            <TaskStatusBadge status={t.status} />
          </Link>
        </li>
      ))}
    </ul>
  );
}
